export const Steps: any = {
  PREVIOUS: 'previous',
  CURRENT: 'current',
  NEXT: 'next',
};

export default Steps;
